import type { MutableState } from 'src/replicant/State';
import {
  HistoryDeathRecord,
  HistoryDuoRecord,
  maxHistoryRecords,
} from './history.ruleset';

/**
 * Create death record in history state.
 */
export function addDeathRecord(
  state: MutableState,
  record: Omit<HistoryDeathRecord, 'type'>,
): void {
  state.history.push({ type: 'death', ...record });
}

/**
 * Create duo record in history state.
 */
export function addPlayerDuoRecord(
  state: MutableState,
  player: Omit<HistoryDuoRecord, 'type'>,
): void {
  state.history.push({ type: 'duo', ...player });
}

/**
 * Keep only 100 last records in history state
 */
export function historyCleanup(state: MutableState): void {
  const history = state.history;

  if (history.length > maxHistoryRecords) {
    history.splice(0, history.length - maxHistoryRecords);
  }
}
